import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import { convertObjectPropsToCamelCase } from '~/lib/utils/common_utils';
import { pinia } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/pinia/instance.js?vue3';
import apolloProvider from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/graphql.js?vue3';
import projectShortPathQuery from './queries/project_short_path.query.graphql';
import projectPathQuery from './queries/project_path.query.graphql';
import HeaderArea from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/header_area.vue?vue3';
import createRouter from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/router.js?vue3';
import refsQuery from './queries/ref.query.graphql';

const initClientQueries = ({ projectPath, projectShortPath, ref, escapedRef }) => {
  // These queries are used in the breadcrumbs component as GraphQL client queries.

  if (projectPath)
    apolloProvider.clients.defaultClient.cache.writeQuery({
      query: projectPathQuery,
      data: { projectPath },
    });

  if (projectShortPath)
    apolloProvider.clients.defaultClient.cache.writeQuery({
      query: projectShortPathQuery,
      data: { projectShortPath },
    });

  if (ref || escapedRef)
    apolloProvider.clients.defaultClient.cache.writeQuery({
      query: refsQuery,
      data: { ref, escapedRef },
    });
};

export default function initHeaderApp({ router, isReadmeView = false }) {
  const headerEl = document.getElementById('js-repository-blob-header-app');
  if (headerEl) {
    const {
      ref,
      escapedRef,
      refType,
      rootRef,
      projectId,
      breadcrumbsCanCollaborate,
      breadcrumbsCanEditTree,
      breadcrumbsCanPushCode,
      breadcrumbsCanPushToBranch,
      breadcrumbsSelectedBranch,
      breadcrumbsNewBranchPath,
      breadcrumbsNewTagPath,
      breadcrumbsNewBlobPath,
      breadcrumbsForkNewBlobPath,
      breadcrumbsForkNewDirectoryPath,
      breadcrumbsForkUploadBlobPath,
      breadcrumbsUploadPath,
      breadcrumbsNewDirPath,
      projectRootPath,
      comparePath,
      projectPath,
      webIdeButtonOptions,
      sshUrl,
      httpUrl,
      xcodeUrl,
      kerberosUrl,
      downloadLinks,
      downloadArtifacts,
      showNoSshKeyMessage,
      userSettingsSshKeysPath,
      projectShortPath,
      isBinary,
      newWorkspacePath,
      organizationId,
      fullName,
      customCodeDropdownClients,
    } = headerEl.dataset;

    let parsedCustomCodeDropdownClients = [];
    try {
      const parsed = JSON.parse(customCodeDropdownClients || '[]');
      if (Array.isArray(parsed)) {
        parsedCustomCodeDropdownClients = parsed.map((client) =>
          convertObjectPropsToCamelCase(client),
        );
      }
    } catch (_e) {
      parsedCustomCodeDropdownClients = [];
    }

    const {
      isFork,
      needsToFork,
      gitpodEnabled,
      isBlob,
      showEditButton,
      showWebIdeButton,
      showGitpodButton,
      showPipelineEditorButton,
      webIdeUrl,
      editUrl,
      pipelineEditorUrl,
      gitpodUrl,
      userPreferencesGitpodPath,
      userProfileEnableGitpodPath,
    } = convertObjectPropsToCamelCase(webIdeButtonOptions ? JSON.parse(webIdeButtonOptions) : {});

    initClientQueries({ projectPath, projectShortPath, ref, escapedRef });

    initVueApp({
      el: headerEl,
      name: 'RepositoryHeaderAreaRoot',
      pinia,
      provide: {
        canCollaborate: parseBoolean(breadcrumbsCanCollaborate),
        canEditTree: parseBoolean(breadcrumbsCanEditTree),
        canPushCode: parseBoolean(breadcrumbsCanPushCode),
        canPushToBranch: parseBoolean(breadcrumbsCanPushToBranch),
        originalBranch: ref,
        selectedBranch: breadcrumbsSelectedBranch,
        newBranchPath: breadcrumbsNewBranchPath,
        newTagPath: breadcrumbsNewTagPath,
        newBlobPath: breadcrumbsNewBlobPath,
        forkNewBlobPath: breadcrumbsForkNewBlobPath,
        forkNewDirectoryPath: breadcrumbsForkNewDirectoryPath,
        forkUploadBlobPath: breadcrumbsForkUploadBlobPath,
        uploadPath: breadcrumbsUploadPath,
        newDirPath: breadcrumbsNewDirPath,
        projectRootPath,
        comparePath,
        isReadmeView,
        isFork: parseBoolean(isFork),
        needsToFork: parseBoolean(needsToFork),
        isGitpodEnabledForUser: parseBoolean(gitpodEnabled),
        isBlob: parseBoolean(isBlob),
        showEditButton: parseBoolean(showEditButton),
        showWebIdeButton: parseBoolean(showWebIdeButton),
        isGitpodEnabledForInstance: parseBoolean(showGitpodButton),
        showPipelineEditorButton: parseBoolean(showPipelineEditorButton),
        webIdeUrl,
        editUrl,
        pipelineEditorUrl,
        gitpodUrl,
        userPreferencesGitpodPath,
        userProfileEnableGitpodPath,
        httpUrl,
        xcodeUrl,
        sshUrl,
        kerberosUrl,
        newWorkspacePath,
        downloadLinks: downloadLinks ? JSON.parse(downloadLinks) : null,
        downloadArtifacts: downloadArtifacts ? JSON.parse(downloadArtifacts) : [],
        showNoSshKeyMessage: parseBoolean(showNoSshKeyMessage),
        userSettingsSshKeysPath,
        isBinary: parseBoolean(isBinary),
        rootRef,
        organizationId,
        customCodeDropdownClients: parsedCustomCodeDropdownClients,
      },
      apolloProvider,
      router: router || createRouter(projectPath, escapedRef, fullName),
      component: HeaderArea,
      props: {
        refType,
        currentRef: ref,
        projectPath,
        projectId,
      },
    });
  }
}
